import React from "react";
import { Row, Col } from 'react-bootstrap';
import { IAminityData } from "../../types/api/aminityApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { ISubAminity } from "../../types/features/multiLanguageSlice";

const AmenitiesSection: React.FC<{ aminities: Array<IAminityData> }> = ({ aminities }) => {
console.log(aminities,'aminities');
const {t} = useTranslation()
    const aminity_json = t('aminity.aminities', { returnObjects: true })  as ISubAminity[];

    return (
        <div>
            <div>
                <section className='amenities-section'>
                    <div className="container">
                        <div className="amenitiescard-content">
                            <Row>
                                {aminities && aminities.length > 0 ?
                                    aminities.map((aminity: IAminityData, index: number) => (
                                        <Col md={4} sm={6} className="p-0" key={"Aminity_" + index}>
                                            <div className="amenities-card card-1">
                                                <div className="amenities-icon">
                                                    <img src={aminity.photo} alt="img" className="img-fluid"></img>
                                                </div>
                                                <div className="amenities-content">
                                                    <h5 className="title">{aminity_json && aminity_json.length>0 &&  aminity_json[index].title}</h5>
                                                    <p className="text">{aminity_json && aminity_json.length>0 && aminity_json[index].description}</p>
                                                </div>
                                            </div>
                                        </Col>
                                    ))
                                    : <NoData message="Oops, No Aminity Data Found!!" />
                                }
                            </Row>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default AmenitiesSection;